import { createSlice } from '@reduxjs/toolkit';
import { getLcs } from 'src/utils';
import { setLcs } from '../../utils';
import { ENUM_LOCALSTORAGE } from '../../enums/enums';

const initialState = {
  activeDir: 'ltr',
  activeMode: getLcs(ENUM_LOCALSTORAGE.themeMode, 'light'), // This can be light or dark
  activeTheme: getLcs(ENUM_LOCALSTORAGE.activeTheme, 'BLUE_THEME'), // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
  SidebarWidth: 270,
  MiniSidebarWidth: 87,
  TopbarHeight: 70,
  isLayout: getLcs(ENUM_LOCALSTORAGE.isLayout, 'boxed'), // This can be full or boxed
  isCollapse: getLcs(ENUM_LOCALSTORAGE.isCollapse, false), // to make sidebar Mini by default
  isSidebarHover: false,
  isMobileSidebar: false,
  isHorizontal: getLcs(ENUM_LOCALSTORAGE.toggleHorizontal, false),
  isCardShadow: getLcs(ENUM_LOCALSTORAGE.isCardShadow, true),
  borderRadius: getLcs(ENUM_LOCALSTORAGE.borderRadius, 7),
  inputSize: 'small'
};

export const CustomizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.activeTheme, action.payload);
      state.activeTheme = action.payload;
    },
    setDarkMode: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.themeMode, action.payload);
      state.activeMode = action.payload;
    },

    setCardShadow: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.isCardShadow, action.payload);
      state.isCardShadow = action.payload;
    },
    toggleSidebar: (state) => {
      const newCollapse = !state.isCollapse;
      setLcs(ENUM_LOCALSTORAGE.isCollapse, newCollapse);
      state.isCollapse = newCollapse;
    },
    hoverSidebar: (state, action) => {
      state.isSidebarHover = action.payload;
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebar = !state.isMobileSidebar;
    },
    toggleLayout: (state, action) => {
      state.isLayout = action.payload;
      setLcs(ENUM_LOCALSTORAGE.isLayout, action.payload);
    },
    toggleHorizontal: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.toggleHorizontal, action.payload);
      state.isHorizontal = action.payload;
    },
    setBorderRadius: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.borderRadius, action.payload);
      state.borderRadius = action.payload;
    }
  }
});

export const {
  setTheme,
  setDarkMode,
  toggleSidebar,
  hoverSidebar,
  toggleMobileSidebar,
  toggleLayout,
  setBorderRadius,
  toggleHorizontal,
  setCardShadow
} = CustomizerSlice.actions;

export default CustomizerSlice.reducer;
